import React from 'react';

export const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop().split(';').shift();
  }
};
export const setCookie = (name = 'cart', value, days = 14) => {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${name}=${value}; expires=${expires}; path=/; SameSite=Lax`;
};

export const updateCartCookie = (value) => setCookie('cart', value, 14);


export const useFormatUSD = () => React.useMemo(() => new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
}), []);

export function numericStringOrNull(value) {
  if (value == null) return null;
  const n = parseFloat(String(value).replace(/[^0-9.]/g, ''));
  return Number.isFinite(n) ? String(n) : null;
}
export const safeJsonParse = (raw, fallback = {}) => {
  if (!raw) return fallback;
  try {
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : fallback;
  } catch {
    return fallback;
  }
};

export const trackKlaviyoEvent = (eventName, properties = {}) => {
  if (typeof window === 'undefined') return;
  const learnq = window._learnq || [];
  learnq.push(['track', eventName, properties]);
};

export function pushDataLayerEvent(eventName, payload = {}) {
  if (typeof window === 'undefined') return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: eventName, ...payload });
}